import { Routes } from '@angular/router';
import { GuestGuard } from './guards/guest.guard';
import { AuthGuard } from './guards/auth.guard';
import { LoginComponent } from './components/login/login.component';
import { EventsComponent } from './components/events/events.component';
import { CamerasComponent } from './components/cameras/cameras.component';
import { EventEditComponent } from './components/event-edit/event-edit.component';
import { CameraEditComponent } from './components/camera-edit/camera-edit.component';
import { ConfigComponent } from './components/config/config.component';
import { ConfigEditComponent } from './components/config-edit/config-edit.component';

const appRoutes: Routes = [
  {
    path: '',
    canActivate: [GuestGuard],
    children: [
      {
        path: 'login',
        component: LoginComponent,
        data: {title: 'Login'}
      }
    ]
  },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'config',
        component: ConfigComponent,
        data: { title: 'Config' }
      },
      {
        path: 'config/create',
        component: ConfigEditComponent,
        data: { title: 'Config' }
      },
      {
        path: 'config/edit/:_id',
        component: ConfigEditComponent,
        data: { title: 'Config' }
      },
      {
        path: 'events',
        component: EventsComponent,
        data: {title: 'Events'}
      },
      {
        path: 'events/create',
        component: EventEditComponent,
        data: {title: 'Events'}
      },
      {
        path: 'events/edit/:_id',
        component: EventEditComponent,
        data: {title: 'Events'}
      },
      {
        path: 'cameras',
        component: CamerasComponent,
        data: {title: 'Cameras'}
      },
      {
        path: 'cameras/create',
        component: CameraEditComponent,
        data: {title: 'Cameras'}
      },
      {
        path: 'cameras/edit/:_id',
        component: CameraEditComponent,
        data: {title: 'Cameras'}
      }
    ]
  },
];

export {appRoutes};



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/app.routes.ts